'use client';

import { SectionHeader } from '../shared';

interface IntentLineBrief {
  line_sid?: string | null;
  name: string;
  qty?: number | null;
  target_price?: number | null;
  brief?: string | null;
  intent_description?: string | null;
}

interface IntentLinesSectionProps {
  lines: IntentLineBrief[] | null | undefined;
  label?: string | null;
}

export function IntentLinesSection({ lines, label }: IntentLinesSectionProps) {
  if (!lines || lines.length === 0) return null;

  return (
    <div>
      <SectionHeader title={label ?? 'Lines'} count={lines.length} />
      <ul className="space-y-1">
        {lines.map((l, idx) => (
          <li
            key={l.line_sid ?? `${l.name}-${idx}`}
            className="p-2 rounded-lg bg-card border border-border"
          >
            <div className="flex items-baseline justify-between gap-2">
              <p className="text-xs font-medium truncate flex-1">
                {l.name || '(unnamed)'}
              </p>
              <span className="text-[10px] text-muted-foreground flex-shrink-0">
                × {l.qty ?? 1}
              </span>
            </div>
            {l.brief && (
              <p className="text-[10px] text-muted-foreground mt-0.5 leading-snug">
                {l.brief}
              </p>
            )}
            {l.intent_description && (
              <p className="text-[11px] italic text-muted-foreground/80 mt-1 leading-relaxed">
                “{l.intent_description}”
              </p>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
